<template>
  <div class="bar">
    <div class="bar-l">
      <div>
        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746414463916_1694569541966.png" />
        {{ todayCnStr }}
      </div>

      <div>
        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746414562412_1694569551139.png" />
        您好！ {{ props.inspectionData.formDataLogin.companyName }} {{ props.inspectionData.formDataLogin.userName }}
      </div>
    </div>

    <div class="bar-r">
      <div @click="gotoPage('login')">
        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-05-05/1746414642776_1694569557044.png" />
        退出登录
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const todayCnStr = dayjs().format("YYYY年MM月DD日");

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};
</script>

<style lang="scss" scoped>
.bar {
  flex: 0 0 auto;
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  background-color: #cfa95e;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  color: #ffffff;

  .bar-l,
  .bar-r {
    display: flex;
    align-items: center;

    > div {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }
    }
  }

  .bar-l {
    > div {
      &:not(:nth-last-of-type(1)) {
        margin-right: 40px;
      }
    }
  }

  .bar-r {
    > div {
      cursor: pointer;
    }
  }
}
</style>
